export function buildTowns (towns) {
    return towns.map(buildTown)
}

export function buildTown (town) {
    return {
        ...town,
    }
}
